<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>星星兑换配置</span>
          <clear-cache-apply />
          <sync-data />
        </div>

        <el-table :data="formData" border stripe>
          <!--          <el-table-column prop="id" label="ID">-->
          <!--            <template v-slot:default="scope">-->
          <!--              <el-input v-model="scope.row.id"  style="width: 100px;" />-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="type" label="兑换类型" style="width: 250px;">
            <template v-slot:default="scope">
              <el-select v-model="scope.row.type" placeholder="请选择">
                <el-option
                  v-for="item in exchangeType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>

          <el-table-column prop="unlock_level" label="野兽数量" style="width: 80px;">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.unlock_level" placeholder="野兽数量" />
            </template>
          </el-table-column>

          <el-table-column prop="bet" label="星星数量" style="width: 80px;">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.star_num" placeholder="星星数量" />
            </template>
          </el-table-column>

          <el-table-column prop="max_exchange" label="兑换数量" style="width: 80px;">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.max_exchange" placeholder="兑换数量" />
            </template>
          </el-table-column>

          <el-table-column prop="prize_json" label="选择宝箱" style="width: 180px;">
            <template v-slot:default="scope">
              <el-select v-model="scope.row.prize_json" multiple placeholder="选择宝箱">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </template>
          </el-table-column>

          <el-table-column prop="refresh_time" label="刷新时间" style="width: 80px;">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.refresh_time" placeholder="刷新时间" />
            </template>
          </el-table-column>

          <el-table-column prop="refresh_time" label="价格" style="width: 80px;">
            <template v-slot:default="scope">
              {{ formatterPrice(scope.row.clear_refresh) }}
            </template>
          </el-table-column>

          <el-table-column prop="max_exchange" label="配置">
            <template v-slot:default="scope">
              <el-button type="text" @click="dialogVisibleArr[scope.$index].visible = true">配置</el-button>
              <el-dialog
                title="兑换价格"
                :visible.sync="dialogVisibleArr[scope.$index].visible"
                width="600px"
                :before-close="(v)=>{return handleClose(v, scope.$index)}"
              >
                <el-form :inline="true">
                  <el-row v-for="(p,i) in scope.row.clear_refresh" :key="i">
                    <el-form-item style="margin-top: 5px;" label="价格倍率">
                      <el-input v-model.number="scope.row.clear_refresh[i]" placeholder="价格倍率" />
                    </el-form-item>
                    <el-form-item style="margin-top: 5px;">
                      <el-button v-permisaction="['config:startExchange:del']" type="danger" @click="delRefresh(scope.$index, i)">删除</el-button>
                    </el-form-item>
                  </el-row>
                  <el-button v-permisaction="['config:startExchange:add']" style="margin-top: 10px;" type="primary" @click="addRefresh(scope.$index)">+</el-button>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisibleArr[scope.$index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="dialogVisibleArr[scope.$index].visible = false">确 定</el-button>
                </span>
              </el-dialog>
            </template>
          </el-table-column>

          <el-table-column>
            <template v-slot:default="scope">
              <el-button v-permisaction="['config:startExchange:del']" type="danger" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>

        </el-table>

        <div style="text-align: center">
          <el-button v-permisaction="['config:startExchange:add']" type="primary" @click="add()">+</el-button>
          <el-button v-permisaction="['config:startExchange:add']" type="primary" @click="onSubmit()">保存</el-button>
        </div>

        <!---->
        <!--        <el-form :inline="true" class="demo-form-inline">-->
        <!--          <el-row v-for="(item, index) in formData" :key="index">-->
        <!--            <el-form-item label="ID">-->
        <!--              <el-input v-model.number="item.id" readonly style="width: 100px;" placeholder="ID" />-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="兑换类型">-->
        <!--              <el-select v-model="item.type" style="width: 180px;" placeholder="请选择">-->
        <!--                <el-option-->
        <!--                  v-for="item in exchangeType"-->
        <!--                  :key="item.value"-->
        <!--                  :label="item.label"-->
        <!--                  :value="item.value"-->
        <!--                />-->
        <!--              </el-select>-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="野兽数量">-->
        <!--              <el-input v-model.number="item.unlock_level" style="width: 100px;" placeholder="野兽数量" />-->
        <!--            </el-form-item>-->
        <!--            &lt;!&ndash;            <el-form-item label="野兽数量">&ndash;&gt;-->
        <!--            &lt;!&ndash;              <el-input v-model.number="item.beast_num" style="width: 100px;" placeholder="野兽数量" />&ndash;&gt;-->
        <!--            &lt;!&ndash;            </el-form-item>&ndash;&gt;-->
        <!--            <el-form-item label="星星数量">-->
        <!--              <el-input v-model.number="item.star_num" style="width: 100px;" placeholder="星星数量" />-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="兑换数量">-->
        <!--              <el-input v-model.number="item.max_exchange" style="width: 100px;" placeholder="兑换数量" />-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="选择宝箱">-->
        <!--              <el-select v-model="item.prize_json" multiple placeholder="请选择">-->
        <!--                <el-option-->
        <!--                  v-for="item in options"-->
        <!--                  :key="item.id"-->
        <!--                  :label="item.name"-->
        <!--                  :value="item.id"-->
        <!--                />-->
        <!--              </el-select>-->
        <!--            </el-form-item>-->
        <!--            &lt;!&ndash;            <el-form-item label="体力">&ndash;&gt;-->
        <!--            &lt;!&ndash;              <el-input v-model.number="item.min_spin" style="width: 80px;" placeholder="最小体力" />&ndash;&gt;-->
        <!--            &lt;!&ndash;            </el-form-item>&ndash;&gt;-->
        <!--            &lt;!&ndash;            <el-form-item label="-">&ndash;&gt;-->
        <!--            &lt;!&ndash;              <el-input v-model.number="item.max_spin" style="width: 80px;" placeholder="最大体力" />&ndash;&gt;-->
        <!--            &lt;!&ndash;            </el-form-item>&ndash;&gt;-->
        <!--            <el-form-item label="刷新时间">-->
        <!--              <el-input v-model.number="item.refresh_time" style="width: 100px;" placeholder="刷新时间" />-->
        <!--            </el-form-item>-->
        <!--            <el-form-item>-->
        <!--              <el-button type="text" @click="dialogVisibleArr[index].visible = true">兑换价格 配置</el-button>-->
        <!--              <el-dialog-->
        <!--                title="兑换价格"-->
        <!--                :visible.sync="dialogVisibleArr[index].visible"-->
        <!--                width="500px"-->
        <!--                :before-close="(v)=>{return handleClose(v, index)}"-->
        <!--              >-->
        <!--                <el-form>-->
        <!--                  <el-row v-for="(p,i) in item.clear_refresh" :key="i">-->
        <!--                    <el-form-item style="margin-top: 10px;" label="价格倍率">-->
        <!--                      <el-input v-model.number="item.clear_refresh[i]" placeholder="价格倍率" />-->
        <!--                    </el-form-item>-->
        <!--                    <el-form-item style="margin-top: 10px;">-->
        <!--                      <el-button v-permisaction="['config:startExchange:del']" type="danger" @click="delRefresh(index, i)">删除</el-button>-->
        <!--                    </el-form-item>-->
        <!--                  </el-row>-->
        <!--                  <el-button v-permisaction="['config:startExchange:add']" style="margin-top: 10px;" type="primary" @click="addRefresh(index)">+</el-button>-->
        <!--                </el-form>-->
        <!--                <span slot="footer" class="dialog-footer">-->
        <!--                  <el-button @click="dialogVisibleArr[index].visible = false">取 消</el-button>-->
        <!--                  <el-button type="primary" @click="dialogVisibleArr[index].visible = false">确 定</el-button>-->
        <!--                </span>-->
        <!--              </el-dialog>-->
        <!--            </el-form-item>-->
        <!--            <el-form-item>-->
        <!--              <el-button v-permisaction="['config:card-process:del']" type="danger" @click="del(item.id, index)">删除</el-button>-->
        <!--            </el-form-item>-->
        <!--          </el-row>-->
        <!--          <el-form-item>-->
        <!--            <el-button v-permisaction="['config:startExchange:add']" type="primary" @click="add()">+</el-button>-->
        <!--          </el-form-item>-->
        <!--          <el-button v-permisaction="['config:startExchange:add']" type="primary" @click="onSubmit()">保存</el-button>-->
        <!--        </el-form>-->

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { delStarChangeList, getStarChangeList, updateStarChangeCfg } from '@/api/config/star-exchange-cfg'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import SyncData from '@/components/syncData/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
export default {
  name: 'StarExchange',
  components: { ClearCacheApply, SyncData },
  data() {
    return {
      dialogVisibleArr: [{ visible: false }],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      propsId: 19,
      exchangeType: [
        { label: '星星兑换类宝箱', value: 1 },
        // { label: '特殊宝箱', value: 2 },
        { label: '超级星星兑换宝箱', value: 2 }
      ],
      options: [],
      formData: [
        {
          'id': 0,
          'type': 10,
          'unlock_level': 0,
          'star_num': 0,
          'beast_num': 0,
          'max_exchange': 0,
          'min_spin': 0,
          'max_spin': 0,
          'refresh_time': 0,
          'clear_refresh': [0]
        }
      ]
    }
  },
  created() {
    this.getTables()
    this.getChestSkin()
  },
  methods: {
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.prize_json.length <= 0) {
          this.msgError('请选择宝箱')
          return
        }
        if (_data.type === 1 && _data.prize_json.length > 1) {
          // this.msgError('星星兑换宝箱只能选一个')
          // return
        }

        if (_data.max_exchange <= 0) {
          this.msgError('兑换数量不能为0')
          return
        }

        const prize = _data.prize_json
        console.log(prize)
        for (const p in prize) {
          this.formData[i].prize_json = []
          this.formData[i].prize_json.push({
            propsId: this.propsId,
            num: 1,
            skin: parseInt(prize[p]),
            rtype: 2
          })
        }
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
      }
      updateStarChangeCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.formData = []
      getStarChangeList().then(res => {
        this.formData = res.data
        for (const i in this.formData) {
          const _data = this.formData[i]
          _data.prize_json.forEach((v) => {
            this.formData[i].prize_json = []
            this.formData[i].prize_json.push(v.skin)
          })
        }
        res.data.forEach(item => {
          this.dialogVisibleArr.push({ visible: false })
        })
      })
    },
    add() {
      const id = this.formData.length
      this.formData.push({
        'id': id + 1,
        'type': 1,
        'unlock_level': 0,
        'star_num': 0,
        'beast_num': 0,
        'max_exchange': 0,
        'min_spin': 0,
        'max_spin': 0,
        'refresh_time': 0,
        'clear_refresh': [0],
        'prize_json': []
      })
      this.dialogVisibleArr.push({ visible: false })
    },
    del(id, index) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delStarChangeList({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    handleClose(done, index) {
      this.dialogVisibleArr[index].visible = false
    },
    addRefresh(index) {
      this.formData[index].clear_refresh.push(0)
    },
    delRefresh(index, i) {
      this.formData[index].clear_refresh = this.formData[index].clear_refresh.filter((item, key) => {
        return i !== key
      })
    },
    getChestSkin() {
      getChestCfgAll().then(res => {
        if (res.code === 200) {
          this.options = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    formatterPrice(row) {
      const text = []
      for (const i in row) {
        text.push(row[i])
      }

      return text.join(',')
    }
  }
}
</script>

<style scoped>
</style>
